var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendarGrey = function SvgCalendarGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M5.916 2.5h5.604V.937a.935.935 0 1 1 1.868 0V2.5h1.557c1.374 0 2.49 1.12 2.49 2.5v12.5c0 1.379-1.116 2.5-2.49 2.5H2.491A2.496 2.496 0 0 1 0 17.5V5c0-1.38 1.115-2.5 2.49-2.5h1.558V.937a.935.935 0 1 1 1.868 0V2.5Zm-4.048 15c0 .344.279.625.623.625h12.454a.626.626 0 0 0 .623-.625v-10h-13.7v10Z"
  })));
};
export default SvgCalendarGrey;